// const aboutPara  = `
// Writing automated tests is an overhead but also a necessity at the same time.\n
// Ideally, writing automated tests should be a no-brainer so the engineer can focus on the application
// ensuring the test coverage at the same time.
// This is exactly what Effortless Test aims to achieve - helping you write your API tests effortlessly in an instant.
// `
const aboutPara  = [
'EffortlessTest is a REST API testing tool designed with a bold goal: to make writing and running API tests ridiculously simple.',
// 'While many tools make sending API requests easy, writing actual tests is often far from it.',
// 'That’s where EffortlessTest shines — it transforms test creation into a truly effortless experience. In fact, you can write a test with just one mouse click. Yes, literally one click.'
];
const data = {
  Navigation: {
    title: 'Effortless Test',
    // smallImage: 'img/effortless_icon.png'
    smallImage: 'img/logo.png'
  },
  Header: {
    // title: 'The easiest REST API testing tool',
    title: 'Test REST with just a click',
    paragraph: 'Request > Response > Assertion(Click) > Done ...Literally!'
  },
  About: {
    paragraph: aboutPara,
    Why: [
      'Easy to use UI',
      'Intuitive and no-brainer',
      'Interactive JSON',
      'Works on win/mac/linux'
    ],
    Why2: [
      'Executes locally and on CI',
      '1 click assertion',
      '',
      'Lorem ipsum dolor'
    ]
  },
  Gallery: [
    {
      title: 'Project Title',
      largeImage: 'img/portfolio/01-large.jpg',
      smallImage: 'img/portfolio/01-small.jpg',
      // a simple test
      embedId: 'mGw4yyQoVxs'
    },
    {
      title: 'Project Title',
      largeImage: 'img/portfolio/02-large.jpg',
      smallImage: 'img/portfolio/02-small.jpg',
      // select all with unverify
      embedId: 'PXCK0IPKFk0'
    },
    {
      title: 'Project Title',
      largeImage: 'img/portfolio/03-large.jpg',
      smallImage: 'img/portfolio/03-small.jpg',
      // understanding green ticks
      embedId: 'Z0EEaaHrF2c'
    },
    {
      title: 'Project Title',
      largeImage: 'img/portfolio/04-large.jpg',
      smallImage: 'img/portfolio/04-small.jpg',
      // working with auth
      embedId: 'kQZ9SIcpHiM'
    },
    {
      title: 'Project Title',
      largeImage: 'img/portfolio/05-large.jpg',
      smallImage: 'img/portfolio/05-small.jpg',
      // using multiple envs
      embedId: 'jQayTw2DHvA'
    },
    {
      title: 'Project Title',
      largeImage: 'img/portfolio/06-large.jpg',
      smallImage: 'img/portfolio/06-small.jpg',
      // using dynamic data
      embedId: 'meh8vefSfVE'
    },
    {
      title: 'Project Title',
      largeImage: 'img/portfolio/07-large.jpg',
      smallImage: 'img/portfolio/07-small.jpg',
      // multiple requests in a test
      embedId: 'y8xS2bjgQ8c'
    },
    {
      title: 'Project Title',
      largeImage: 'img/portfolio/08-large.jpg',
      smallImage: 'img/portfolio/08-small.jpg',
      // running multiple tests
      embedId: 'fCF4rtiVZgU'
    },
    {
      title: 'Project Title',
      largeImage: 'img/portfolio/09-large.jpg',
      smallImage: 'img/portfolio/09-small.jpg',
      // asserting with regex
      embedId: '3Q74_G67Feg'
    },
    {
      title: 'Project Title',
      largeImage: 'img/portfolio/09-large.jpg',
      smallImage: 'img/portfolio/09-small.jpg',
      // variables with auto suggest
      embedId: 'VkA6TPRDy2E'
    },
    {
      title: 'Project Title',
      largeImage: 'img/portfolio/09-large.jpg',
      smallImage: 'img/portfolio/09-small.jpg',
      // running tests on CI
      embedId: 'E045VFY8Res'
    }
  ],
  Compare: [
    {
      icon: 'fa fa-wordpress',
      name: 'Lorem ipsum dolor',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed dapibus leo nec ornare diam sedasd commodo nibh ante facilisis bibendum dolor feugiat at.'
    },
    {
      icon: 'fa fa-cart-arrow-down',
      name: 'Consectetur adipiscing',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed dapibus leo nec ornare diam sedasd commodo nibh ante facilisis bibendum dolor feugiat at.'
    },
    {
      icon: 'fa fa-cloud-download',
      name: 'Lorem ipsum dolor',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed dapibus leo nec ornare diam sedasd commodo nibh ante facilisis bibendum dolor feugiat at.'
    },
    {
      icon: 'fa fa-language',
      name: 'Consectetur adipiscing',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed dapibus leo nec ornare diam sedasd commodo nibh ante facilisis bibendum dolor feugiat at.'
    },
    {
      icon: 'fa fa-plane',
      name: 'Lorem ipsum dolor',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed dapibus leo nec ornare diam sedasd commodo nibh ante facilisis bibendum dolor feugiat at.'
    },
    {
      icon: 'fa fa-pie-chart',
      name: 'Consectetur adipiscing',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed dapibus leo nec ornare diam sedasd commodo nibh ante facilisis bibendum dolor feugiat at.'
    }
  ],
  Testimonials: [
    // {
    //   img: 'img/testimonials/01.jpg',
    //   text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed dapibus leo nec ornare diam sedasd commodo nibh ante facilisis bibendum dolor feugiat at.',
    //   name: 'John Doe'
    // },
    // {
    //   img: 'img/testimonials/02.jpg',
    //   text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed dapibus leo nec ornare diam sedasd commodo nibh ante facilisis bibendum dolor feugiat at.',
    //   name: 'Johnathan Doe'
    // },
    // {
    //   img: 'img/testimonials/03.jpg',
    //   text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed dapibus leo nec ornare diam sedasd commodo nibh ante facilisis bibendum dolor feugiat at.',
    //   name: 'John Doe'
    // },
    // {
    //   img: 'img/testimonials/04.jpg',
    //   text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed dapibus leo nec ornare diam sedasd commodo nibh ante facilisis bibendum dolor feugiat at.',
    //   name: 'Johnathan Doe'
    // },
    // {
    //   img: 'img/testimonials/05.jpg',
    //   text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed dapibus leo nec ornare diam sedasd commodo nibh ante facilisis bibendum dolor feugiat at.',
    //   name: 'John Doe'
    // },
    // {
    //   img: 'img/testimonials/06.jpg',
    //   text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis sed dapibus leo nec ornare diam sedasd commodo nibh ante facilisis bibendum dolor feugiat at.',
    //   name: 'Johnathan Doe'
    // }
  ],
  Team: [
    {
      img: 'img/team/01.jpg',
      name: 'John Doe',
      job: 'Director'
    },
    {
      img: 'img/team/02.jpg',
      name: 'Mike Doe',
      job: 'Senior Designer'
    },
    {
      img: 'img/team/03.jpg',
      name: 'Jane Doe',
      job: 'Senior Designer'
    },
    {
      img: 'img/team/04.jpg',
      name: 'Karen Doe',
      job: 'Project Manager'
    }
  ],
  Contact: {
    linkedin1: 'www.linkedin.com/in/karanvaid',
    linkedin2: 'www.linkedin.com/in/ankur-vaid-7b338772/',
    email1: 'team.effortlesstest@gmail.com',
  },
  Features: [
    {
      icon: 'img/features/intuitive.png',
      title: 'Intuitive interface',
      text: ''
    },
    {
      icon: 'img/features/interactive.png',
      title: 'Interactive JSON',
      text: ''
    },
    {
      icon: 'img/features/click.png',
      title: 'One click assertion',
      text: ''
    },
    {
      icon: 'img/features/pipeline.png',
      title: 'Runs on CI',
      text: ''
    },
    {
      icon: 'img/features/cloudStorage.png',
      title: 'Cloud storage',
      text: ''
    },
    {
      icon: 'img/features/os.png',
      title: 'Runs on Win/Mac/Linux',
      text: ''
    },
    {
      icon: 'img/features/multipleEnvs.png',
      title: 'Designed for multi-environment workflows',
      text: ''
    },
    {
      icon: 'img/features/easy.png',
      title: 'Easy to use',
      text: ''
    },
  ]
}

export default data;